var _VegaPhotoLoader_instances, _a, _VegaPhotoLoader_HOST, _VegaPhotoLoader_getUri;
import { __classPrivateFieldGet } from "tslib";
import axios from 'axios';
export class VegaPhotoLoader {
    constructor() {
        _VegaPhotoLoader_instances.add(this);
    }
    async load(params) {
        try {
            const { data } = await axios.get(__classPrivateFieldGet(this, _VegaPhotoLoader_instances, "m", _VegaPhotoLoader_getUri).call(this, params));
            return data.map((dto) => {
                const tag = dto.tag || '';
                const tags = tag.split(',').filter((t) => t.length > 0);
                return {
                    hash: dto.hash,
                    height: dto.height,
                    isForAdult: dto.adult,
                    mimeType: dto.mimeType,
                    regDate: new Date(dto.regDate),
                    tags,
                    url: dto.url,
                    viewer: 0,
                    width: dto.width,
                };
            });
        }
        catch (_b) {
            return [];
        }
    }
}
_a = VegaPhotoLoader, _VegaPhotoLoader_instances = new WeakSet(), _VegaPhotoLoader_getUri = function _VegaPhotoLoader_getUri(params) {
    const urlParams = new URLSearchParams();
    urlParams.set('q', params.q);
    urlParams.set('start', params.start.toString());
    urlParams.set('num', params.length.toString());
    return `${__classPrivateFieldGet(_a, _a, "f", _VegaPhotoLoader_HOST)}?${urlParams.toString()}`;
};
_VegaPhotoLoader_HOST = { value: 'https://mycast.xyz:9011/photo' };
